module.exports = __webpack_public_path__ + "img/avatar_place.7d203a73.png";